/** Подсказку у колокольчика «следить за ходом можно здесь» пользователь видит столько раз — дальше он знает. */
export const BELL_HINT_LIMIT = 3;
/** Подсказка — не диалог: закрывается сама. */
export const BELL_HINT_MS = 5_000;

const storageKey = (userId: number | string) => `bellJobHintShown:v1:${userId}`;

/** Сколько раз подсказку уже показали; хранилище недоступно — как будто показали все разы: не навязываем. */
export const readBellHintCount = (userId: number | string): number => {
    try {
        const value = Number.parseInt(localStorage.getItem(storageKey(userId)) ?? '0', 10);
        return Number.isFinite(value) && value > 0 ? value : 0;
    } catch {
        return BELL_HINT_LIMIT;
    }
};

export const bumpBellHintCount = (userId: number | string): void => {
    try {
        localStorage.setItem(storageKey(userId), String(readBellHintCount(userId) + 1));
    } catch {
        /* хранилище недоступно — не сохраняем */
    }
};

export interface IBellHintInput {
    shownCount: number;
    /** Открыт дропдаун колокольчика: задачу и так видно строкой раздела. */
    dropdownOpen: boolean;
    /** У колокольчика стопка превью уведомлений: подсказка легла бы на неё. */
    toastsShown: boolean;
}

export const shouldShowBellHint = ({ shownCount, dropdownOpen, toastsShown }: IBellHintInput): boolean =>
    shownCount < BELL_HINT_LIMIT && !dropdownOpen && !toastsShown;
